var map = {
	"./18068 copy.jpg": "8a01",
	"./18068.png": "fd12",
	"./AppStore.png": "9da0",
	"./Gplay.png": "0a06",
	"./MunMunGames_Simple.png": "708c",
	"./OP.jpg": "d59a",
	"./Out Fishing main capsule.png": "ff34",
	"./PlayNow.png": "d843",
	"./SC01_07.png": "5d7e",
	"./The Daruma Challenge main capsule_alt.png": "6468",
	"./Wishlist.png": "048e",
	"./badge-color.png": "6d0f",
	"./rocket-heading-for-the-moon-5272600-4411742.png": "ad29",
	"./stars-in-night-sky.jpg": "a795"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d25";